/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_How_1Inputs */

const en_coaching_how_1 = /** @type {(inputs: Coaching_How_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserve a session — it is deducted from your monthly quota or extra credits.`)
};

const id_coaching_how_1 = /** @type {(inputs: Coaching_How_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan sesi — dipotong dari kuota bulanan atau kredit tambahan.`)
};

/**
* | output |
* | --- |
* | "Reserve a session — it is deducted from your monthly quota or extra credits." |
*
* @param {Coaching_How_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_how_1 = /** @type {((inputs?: Coaching_How_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_How_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_how_1(inputs)
	return en_coaching_how_1(inputs)
});